<template>
  <ValidationObserver v-slot="{ invalid, handleSubmit }" class="col-lg-12">
    <form @submit.prevent="handleSubmit(updateShiftType)" class="justify-content-between col-lg-12 py-3">
      <div class="form-row align-items-center py-3">
        <TextInputField
            labelText="shiftnaam" class="form-group col-lg-6"
            v-model="shiftType.name"
            maxLength="20" required/>
        <ColorInputField
            labelText="shiftkleur" class="form-group col-md-6"
            required v-model="shiftType.color"/>
      </div>

      <ValidationObserver tag="div" class="form-row align-items-center py-3">
        <TimeInputField
            class="form-group col-lg-6" v-model="shiftType.labourTime.startTime"
            labelText="startuur" required
            vid="startTime"/>
        <TimeInputField
            class="form-group col-lg-6" v-model="shiftType.labourTime.endTime"
            labelText="einduur" required
            :crossFieldRules="['notSame:@startTime']"/>
      </ValidationObserver>

      <div class="form-row col-12 mb-3 justify-content-center">
        <div class="custom-control custom-switch">
          <input
              type="checkbox" class="custom-control-input"
              id="pause" v-model="breakHoursShow"/>
          <label class="custom-control-label" for="pause">Vaste pauze-uren?</label>
        </div>
      </div>

      <ValidationObserver
          v-if="breakHoursShow"
          tag="div" class="form-row align-items-center py-3">
        <TimeInputField
            class="form-group col-lg-6" v-model="shiftType.breakTime.startTime"
            labelText="pauze startuur" vid="breakStartTime"
            :crossFieldRules="['required']"/>
        <TimeInputField
            class="form-group col-lg-6" v-model="shiftType.breakTime.endTime"
            labelText="pauze einduur" vid="breakEndTime"
            :crossFieldRules="['required|notSame:@breakStartTime']"/>
      </ValidationObserver>

      <div class="form-row align-items-center py-3">
        <div class="input-group col-6">
          <button
              type="submit" :disabled="invalid"
              class="btn btn-success mr-3">
            Shift type opslaan
          </button>
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {mapActions} from "vuex";
import {ValidationObserver} from "vee-validate";
import TextInputField from "@/components/inputFields/TextInputField";
import TimeInputField from "@/components/inputFields/TimeInputField";
import ColorInputField from "@/components/inputFields/ColorInputField";

export default {
  name: "EditShiftTypeComponent",
  components: {
    ColorInputField,
    TimeInputField,
    TextInputField,
    ValidationObserver
  },
  props: {
    shiftTypeDtoToEdit: {}
  },
  data() {
    return {
      shiftType: {
        id: this.shiftTypeDtoToEdit.id,
        active: this.shiftTypeDtoToEdit.active,
        name: this.shiftTypeDtoToEdit.name,
        color: this.shiftTypeDtoToEdit.color,
        labourTime: {
          startTime: this.shiftTypeDtoToEdit.labourTime?.startTime ?? "00:00:00",
          endTime: this.shiftTypeDtoToEdit.labourTime?.endTime ?? "00:00:00"
        },
        breakTime: {
          startTime: this.shiftTypeDtoToEdit.breakTime?.startTime ?? "00:00:00",
          endTime: this.shiftTypeDtoToEdit.breakTime?.endTime ?? "00:00:00"
        }
      },

      showBreakHoursChecked: false
    };
  },
  computed: {
    breakHoursShow: {
      get: function () {
        return this.showBreakHoursChecked;
      },
      set: function (value) {
        if (value && !this.shiftType.breakTime) {
          this.shiftType.breakTime = {
            startTime: "",
            endTime: ""
          };
        }
        if (!value && !!this.shiftType.breakTime) {
          this.shiftType.breakTime = null;
        }
        this.showBreakHoursChecked = value;
      },
    }
  }
  , created() {
    if (this.shiftType.breakTime) {
      this.showBreakHoursChecked = true;
    }
  }
  ,
  methods: {
    ...mapActions("administrationCustomer", ['updateShiftTypeFromCustomer']),
    async updateShiftType() {
      const editShiftTypeDto = {
        id: this.shiftType.id,
        active: this.shiftType.active,
        name: this.shiftType.name,
        color: this.shiftType.color,
        labourTime: {
          startTime: this.shiftType.labourTime.startTime,
          endTime: this.shiftType.labourTime.endTime
        },
        breakTime: this.shiftType.breakTime
      };
      await this.updateShiftTypeFromCustomer(editShiftTypeDto).then(() => {
        this.resetFields();
        this.$emit('shiftTypeEdited');
      });
    },
    resetFields() {
      this.shiftName = "";
      this.color = "#FFFFFF";
      this.startTime = "";
      this.endTime = "";
      this.breakStartTime = "";
      this.breakEndTime = "";
      this.breakHoursShow = false;
    },
  }
};
</script>

<style scoped>

</style>
